<template>
    <div>
        <div id="cnCdStock" style="width: 100%;height:calc(100vh - 84px);overflow-x: auto;">
            <div style="display: flex; width: 100%; justify-content: space-between; flex-wrap: nowrap;background-color: #fff;">
               
                <vxe-form v-bind="formOptions" style="flex-wrap: wrap;overflow-x: hidden;  ">
                </vxe-form>
                <vxe-toolbar ref="toolbarRef" custom>
                </vxe-toolbar>
            </div>
 <!-- <div style="display: flex; width: 100%; justify-content: space-between; flex-wrap: wrap;">
                <vxe-form v-bind="formOptions" style="min-width: 300px; flex-grow: 1;flex-shrink: 1;">
                </vxe-form>
                <vxe-toolbar ref="toolbarRef" custom style="min-width: 200px; flex-grow: 1;flex-shrink: 1;">
                </vxe-toolbar>
            </div> -->
            <vxe-table id="cnCdStock" :data="tableData" border :column-config="{ resizable: true }" class="table-style"
                :columns="columns" stripe width="100%"  :custom-config="customConfig" ref="tableRef" >
                <vxe-column type="seq" width="50" align="center"></vxe-column>
                <vxe-column v-for="(column, index) in columns" :field="column.field" :title="column.title"
                    align="center">
                    <template #default="{ row, column }">
                        <!-- 判断字段值并渲染不同的内容 -->
                        <vxe-tag v-if="column.field === 'resultCode' && row[column.field] === 'success'"
                            status="success">发送成功</vxe-tag>
                        <vxe-tag v-if="column.field === 'resultCode' && row[column.field] === 'failed'"
                            status="error">发送失败</vxe-tag>
                        <span v-if="column.field !== 'resultCode'"> {{ row[column.field] }} </span>
                    </template>
                </vxe-column>
                <!-- <vxe-column title="操作" width="250" align="center">
                    <template #default="{ row }">
                        <vxe-button mode="text" status="success" icon="vxe-icon-edit"
                            @click="editEvent(row)">编辑</vxe-button>
                        <vxe-button mode="text" status="error" icon="vxe-icon-edit"
                            @click="deleteEvent(row)">删除</vxe-button>
                    </template>
                </vxe-column> -->
            </vxe-table>

            <!-- <vxe-modal resize destroy-on-close show-footer show-confirm-button show-cancel-button
                v-model="showEditPopup" :title="selectRow ? '编辑' : '新增'" width="70vw" height="35vh" :loading="loading"
                :confirm-closable="false" @confirm="confirmEvent" @cancel="cancelEvent" @close="cancelEvent">
                <vxe-form ref="formRef" class="form-style" v-bind="formOptionsAdd"></vxe-form>
            </vxe-modal> -->

        </div>
    </div>
</template>

<script>
import { VxeUI } from 'vxe-pc-ui'
import req from '@/utils/index.js'
import url from '@/config/url1.js'
import XEUtils from 'xe-utils'
// 表格自适应
import userProfile from '@/mixins/userProfile.js'
export default {
    name: 'cdStockInfo',
    mixins: [userProfile],
    //组件创建
    created() {
        // this.loadTableData();
    },
    data() {
        const formOptions = {
            data: {
                startTime: '',
                endTime: '',
            },
            items: [
                { field: 'startTime', title: '发送时间', span: 6, itemRender: { name: 'VxeDatePicker' } },
                { field: 'endTime', title: '结束时间', span: 6, itemRender: { name: 'VxeDatePicker' } },
                {
                    span: 6,
                    // collapseNode: true,
                    align: 'center',
                    itemRender: {
                        name: 'VxeButtonGroup',
                        options: [
                            { type: 'submit', content: '搜索日志', status: 'primary', name: 'search', style: 'min-width: 80px' },
                            { type: 'submit', content: '发送入库', status: 'success', name: 'obtainInventory', style: 'min-width: 80px' }, 
                            { type: 'submit', content: '发送出库', status: 'error', name: 'acquireInventory', style: 'min-width: 80px' },
                            { type: 'submit', content: '发送库存', status: 'warning', name: 'getInventory', style: 'min-width: 80px' },                                                
                            { type: 'reset', content: '重置', name: 'reset', status: 'info',style: 'min-width: 80px' },


                        ],
                        events: {
                            click: this.handleButtonClick // 调用 methods 中的方法
                        }
                    }
                }
            ]
        }
        // const formOptionsAdd = {
        //     titleWidth: 80,
        //     titleAlign: 'right',
        //     titleColon: true,
        //     data: {
        //         id: '',
        //         companyName: '',
        //         hsCode: '',
        //         creditCode: '',
        //         shortName: '',
        //         contactName: ''
        //     },
        //     rules: {
        //         companyName: [
        //             { required: true, message: '请输入名称' },
        //         ],
        //         hsCode: [
        //             { required: true, message: '请选择海关编码' }
        //         ],
        //         creditCode: [
        //             { required: true, message: '统一社会信用代码' }
        //         ],
        //         shortName: [
        //             { required: true, message: '企业简称' }
        //         ],
        //         contactName: [
        //             { required: true, message: '联系人' }
        //         ]
        //     },
        //     items: [
        //         { field: 'companyName', title: '企业名称', span: 12, itemRender: { name: 'VxeInput' } },
        //         { field: 'hsCode', title: '海关编码', span: 12, itemRender: { name: 'VxeInput' } },
        //         { field: 'creditCode', title: '统一社会信用代码', span: 12, itemRender: { name: 'VxeInput' } },
        //         { field: 'shortName', title: '企业简称', span: 12, itemRender: { name: 'VxeInput' } },
        //         { field: 'contactName', title: '联系人', span: 24, itemRender: { name: 'VxeInput' } },
        //         // {
        //         //     span: 3,
        //         //     // collapseNode: true,
        //         //     align: 'center',
        //         //     // itemRender: {
        //         //     //     name: 'VxeButtonGroup',
        //         //     //     options: [
        //         //     //         { type: 'submit', content: '搜索', status: 'primary' },
        //         //     //         { type: 'reset', content: '重置' }
        //         //     //     ]
        //         //     // }
        //         // }
        //     ]
        // }
        return {
            tableData: [],
            columns: [],
            formOptions,
            // formOptionsAdd,
            showEditPopup: false,
            loading: false,
            selectRow: undefined,
            isAddEdit: null,
        }
    },
    methods: {

        handleButtonClick(options, button) {
            switch (button.name) {
                case 'search':
                    this.submitEvent();
                    break;
                case 'reset':
                    this.resetEvent();
                    break;
                case 'getInventory':
                    this.getInventory();
                    break;
                case 'acquireInventory':
                    this.acquireInventory();
                    break;
                case 'obtainInventory':
                    this.obtainInventory();
                    break;
            }
        },
        // 获取库存
        getInventory(){
            // this.$api.getDongShengStock( ).then(res =>{
            //     this.$message({
            //         type: "success",
            //         message: res.data.message,
            //     });
            // })
            let URL = `${url.getDongShengStock}`;
            req.post(URL).then((res) => {
                if (res.data.code === 200) {
                    this.$message({
                        type: "success",
                        message: res.data.message,
                    });
                } else {
                    this.$message({
                        type: "error",
                        message: res.data.message,
                    });
                }
            })
        },
        acquireInventory(){
            let URL = `${url.getDongShengOutInfo}`;
            req.post(URL).then((res) => {
                if (res.data.code === 200) {
                    this.$message({
                        type: "success",
                        message: res.data.message,
                    });
                } else {
                    this.$message({
                        type: "error",
                        message: res.data.message,
                    });
                }
            })
        },
        obtainInventory(){
            let URL = `${url.getDongShengInInfo}`;
            req.post(URL).then((res) => {
                if (res.data.code === 200) {
                    this.$message({
                        type: "success",
                        message: res.data.message,
                    });
                } else {
                    this.$message({
                        type: "error",
                        message: res.data.message,
                    });
                }
            })
        },
        // 查询
        submitEvent(options) {
            // this.formOptions.data.startTime = this.formOptions.data.startTime + '00:00:00';
            // this.formOptions.data.endTime = this.formOptions.data.endTime + '23:59:59';
            let URL;
            if (this.formOptions.data.endTime == '') {
                URL = `${url.getCdLog}?startTime=${this.formOptions.data.startTime}&endTime=${this.formOptions.data.endTime}`;
            } else if (this.formOptions.data.endTime != '') {
                URL = `${url.getCdLog}?startTime=${this.formOptions.data.startTime}&endTime=${this.formOptions.data.endTime} 23:59:59`;
            } else {
                URL = `${url.getCdLog}?startTime=${this.formOptions.data.startTime}&endTime=${this.formOptions.data.endTime}`;
            }

            req.post(URL).then((res) => {
                if (res.data.code === 200) {
                    this.columns = res.data.data.columns; // 动态列配置
                    this.tableData = res.data.data.tableData; // 表格数据
                } else {
                    VxeUI.modal.message({
                        status: "error",
                        content: res.data.message,
                    });
                }
            });
        },
        // 重置
        resetEvent() {
            this.formOptions.data.startTime = '';
            this.formOptions.data.endTime = '';
        },
        // 加载表格数据和列配置
        loadTableData() {
            // const URL = `${url.getCompanyList}?companyName=`;
            const URL = `${url.getCdLog}?startTime=${this.formOptions.data.startTime}&endTime=${this.formOptions.data.endTime}`;
            req.post(URL).then((res) => {
                if (res.data.code === 200) {
                    this.columns = res.data.data.columns; // 动态列配置
                    this.tableData = res.data.data.tableData; // 表格数据
                } else {
                    VxeUI.modal.message({
                        status: "error",
                        content: res.data.message,
                    });
                }
            });
        },
    }
}
</script>

<style lang="css" scoped>
::v-deep .table-style .vxe-table .vxe-cell {
    padding: 0 !important;
    line-height: 1.3vh;
}

::v-deep .el-form-item__label-wrap {
    margin-left: 0px !important;
}

::v-deep .table-style .vxe-body--column {
    padding: 0 !important;
}

::v-deep .form-style .vxe-form--item-title {
    width: 120px !important;
}

::v-deep .vxe-button {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 60px;
    /* padding:0 2px !important; */
}

::v-deep .vxe-form--wrapper {
    flex: 1;
    width: 100%;
    flex-wrap: wrap !important;
    
}

</style>